import * as React from 'react';
import { AccessDenied } from './index';

export function AccessDeniedToProduct() {
  return (
    <AccessDenied translationKeySuffix='PRODUCT' />
  );
}
